import TutorSelector from './src/main';

/* istanbul ignore next */
TutorSelector.install = function(Vue) {
  Vue.component(TutorSelector.name, TutorSelector);
};

export default TutorSelector;
